module.exports = __webpack_public_path__ + "media/Slap.822516b9.mp3";